// 品牌模式下点击切换到 Hotel 模式（RouterMenu.vue switchModule）时，不能在当前页面直接
// commit hotel/SET_CURRENT_HOTEL —— 这时 BrandOverview2 还挂载着，同步改 currentHotelId
// 会触发它自己的 currentHotelId watcher，在整页跳转/刷新完成前就多发一次请求（这时品牌态已经
// 清空，容易报错）。所以改成把目标 hotelId 存进 sessionStorage，由 store/index.js 在新页面
// 整页加载、store 重新创建时读取并 commit，这样它生效时 BrandOverview2 早已卸载。
export const PENDING_HOTEL_ID_KEY = "wtk:pendingHotelIdFromBrandMode";

// 进入品牌模式前正在看的酒店（RouterMenu.vue switchModule 进入 brand 时记下）。
// 进品牌模式时为了解析所属集团，可能会把 currentHotelId 换成同集团的另一家（见 switchModule），
// 退出时如果只按「品牌旗下第一家」挑，就回不到用户原来的酒店（WTK-672：Grand Luxury 变成 The Dali EDITION）。
// 退出品牌模式切回 Hotel 时优先还原它；用完即删。
export const HOTEL_BEFORE_BRAND_KEY = "wtk:hotelBeforeBrandMode";
